export const tipoBaixaFaseEnum = {
    MANUAL: 1,
    AUTOMATICA: 2,
    PERSONALIZADA: 3
}